import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import type { ValidationErrors } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { isNil } from '@pct/ts-typeguard';

@Pipe({
  name: 'validatorError',
  pure: true, // nem reagál a dinamikus nyelvváltásra jelenleg, cserébe nem fut le minden render-nél
})
export class ValidatorErrorPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(errors: ValidationErrors | null | undefined): string | null {
    if (isNil(errors)) {
      return null;
    }

    // Elég az első hiba kulcsa
    const firstErrorKey = Object.keys(errors)[0];

    // Az Angular által visszaadott részletek (pl. { requiredLength: 5 })
    const errorArgs = errors[firstErrorKey];

    // api által dobott mezőhiba
    if (firstErrorKey === 'apiError') {
      return errorArgs;
    }
    const translationKey = `error.validation.${firstErrorKey}`;

    const params = typeof errorArgs === 'object' ? errorArgs : {};
    return this.translocoService.translate(translationKey, params);
  }
}
